__webpack_require__.p = "https://apps.revivotech.in/hotelx/";